import { cn } from "../index";

export interface CopyrightProps extends React.DetailedHTMLProps<
  React.HTMLAttributes<HTMLParagraphElement>,
  HTMLParagraphElement
> {
  version: string;
  label?: string;
}

export const Copyright: React.FC<CopyrightProps> = ({ version, label, className, ...props }) => {
  const year = new Date().getFullYear();

  return (
    <p {...props} className={cn("text-base text-primary-darker-gray", className)}>
      {label ?? `Eisox © ${year} • ${version}`}
    </p>
  );
};
